import { NavigationGuardNext, Route } from 'vue-router';
import { NamedLocation } from '../types';
import { isOnboardingEnabled } from '@/ui/helpers/featureHelper';

export function guardOnboardingFeatureToggle(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void {
  if (!isOnboardingEnabled()) {
    const redirectTo: NamedLocation = { name: 'home' };
    next(redirectTo);

    return;
  }
  next();
}
